import { FormSelectField, SelectProps } from 'omakase';
import IsoCountryCodes from 'constants/IsoCountryCodes';

type FormIsoCountryCodeFieldProps = Omit<SelectProps, 'children'>;

/**
 * Formik-ready select field that includes all ISO country codes as options
 */
const FormIsoCountryCodeField: React.FunctionComponent<FormIsoCountryCodeFieldProps> = ({
  name = 'isoCountryCode',
  id = 'isoCountryCode',
  label = 'Country',
  inputProps = {
    'data-testid': 'country-code',
    autoComplete: 'country',
  },
  fullWidth = true,
  placeholder = 'Select a country',
  ...rest
}) => {
  return (
    <FormSelectField
      fullWidth={fullWidth}
      name={name}
      id={id}
      label={label}
      inputProps={inputProps}
      placeholder={placeholder}
      {...rest}
    >
      {IsoCountryCodes.map(({ value, key, label }) => (
        <option value={value} key={key}>
          {label}
        </option>
      ))}
    </FormSelectField>
  );
};

export default FormIsoCountryCodeField;
